/*
 * @Author: qiankun 153087222@qq.com
 * @Date: 2023-03-30 10:41:11
 * @LastEditors: qiankun 153087222@qq.com
 * @LastEditTime: 2023-07-24 09:41:58
 * @FilePath: /qcsdjyBigdataUI/src/router/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import VueRouter from "vue-router";
import fzc from "./fzc";
import ly from "./ly";
Vue.use(VueRouter);

const routes = [...fzc, ...ly];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

// router.beforeEach((res)=>{
//   console.log(res)
//   // next()
// })
export default router;
